import React from 'react';

import banniere from '../../images/banner-locevent-final.jpg';

const HeadBanner = () => (
  <img
    style={{

    }}
    alt="banniere-locevent"
    src={banniere}
  />
);

export default HeadBanner;
